var _path, _g, _path2, _g2, _path3, _path4, _g3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g4, _path12, _g5, _path13, _g6, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPercentUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1404_41489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 26,
    width: 6,
    height: 2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.586 27.8716L21.4946 27.5859C21.6835 27.6117 21.8825 27.6249 22.0916 27.6257C23.0507 27.6286 23.8227 27.3661 24.4051 26.8401L26.4964 27.1259C25.914 27.6519 25.142 27.9143 24.1829 27.9114C23.9738 27.9107 23.7748 27.8975 23.586 27.8716Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1404_41489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.586 27.8715L21.4946 27.5858C21.5209 27.5894 21.5474 27.5928 21.574 27.5959L23.6654 27.8816C23.6387 27.8785 23.6122 27.8751 23.586 27.8715Z",
    fill: "url(#paint0_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6655 27.8817L21.5742 27.596C21.7393 27.6152 21.9118 27.6251 22.0917 27.6257C22.2344 27.6261 22.3731 27.6206 22.5074 27.6093L24.5988 27.895C24.4644 27.9064 24.3258 27.9118 24.1831 27.9114C24.0031 27.9108 23.8306 27.9009 23.6655 27.8817Z",
    fill: "url(#paint1_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5987 27.895L22.5073 27.6093C22.9347 27.5734 23.32 27.4781 23.6632 27.3237L25.7545 27.6094C25.4114 27.7638 25.026 27.8591 24.5987 27.895Z",
    fill: "url(#paint2_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7544 27.6094L23.6631 27.3236C23.8647 27.233 24.0517 27.1219 24.224 26.9904L26.3154 27.2761C26.143 27.4076 25.956 27.5187 25.7544 27.6094Z",
    fill: "url(#paint3_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.315 27.2761L24.2236 26.9904C24.2859 26.943 24.3462 26.8928 24.4046 26.8401L26.496 27.1258C26.4375 27.1786 26.3772 27.2287 26.315 27.2761Z",
    fill: "url(#paint4_linear_1404_41489)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1404_41489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 20,
    width: 5,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0151 20.7017L25.1065 20.9875C25.7836 21.08 26.331 21.3338 26.7476 21.7484C27.2829 22.2779 27.5199 23.1751 27.4607 24.4392C27.4016 25.7022 27.0809 26.5978 26.496 27.1257L24.4047 26.84C24.9895 26.3121 25.3103 25.4165 25.3694 24.1534C25.4285 22.8894 25.1916 21.9922 24.6563 21.4626C24.2397 21.0481 23.6923 20.7943 23.0151 20.7017Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1404_41489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4961 27.1257L24.4048 26.84C24.4959 26.7577 24.5806 26.6666 24.6589 26.5665L26.7502 26.8522C26.6719 26.9523 26.5873 27.0435 26.4961 27.1257Z",
    fill: "url(#paint5_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7501 26.8523L24.6588 26.5666C25.0831 26.0242 25.3195 25.2199 25.3694 24.1536C25.4285 22.8895 25.1916 21.9923 24.6563 21.4628C24.2397 21.0482 23.6923 20.7944 23.0151 20.7019L25.1065 20.9876C25.7836 21.0801 26.331 21.3339 26.7476 21.7485C27.2829 22.278 27.5199 23.1752 27.4607 24.4393C27.4109 25.5056 27.1744 26.31 26.7501 26.8523Z",
    fill: "url(#paint6_linear_1404_41489)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2875 8.05908L26.1962 7.77337L23.6309 6.54282L25.7222 6.82853L28.2875 8.05908Z",
    fill: "url(#paint7_linear_1404_41489)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1404_41489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 18,
    width: 12,
    height: 13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4798 30.1274L20.3885 29.8417C18.9903 29.6506 17.8826 29.1969 17.0666 28.4799C15.9616 27.5091 15.4549 26.0571 15.5454 24.1226C15.636 22.1882 16.2783 20.7397 17.4737 19.7761C18.6692 18.8125 20.354 18.3346 22.5259 18.3414C23.0941 18.3432 23.6258 18.3779 24.121 18.4455L26.2123 18.7312C25.7172 18.6636 25.1855 18.6289 24.6172 18.6271C22.4453 18.6203 20.7605 19.0982 19.5651 20.0618C18.3696 21.0254 17.7273 22.4739 17.6368 24.4084C17.5463 26.3428 18.0529 27.7948 19.1579 28.7657C19.9739 29.4826 21.0816 29.9364 22.4798 30.1274Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1404_41489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4798 30.1274L20.3885 29.8417C18.9902 29.6506 17.8826 29.1969 17.0666 28.4799C15.9616 27.5091 15.4549 26.0571 15.5454 24.1226C15.6145 22.6464 16.005 21.4531 16.7174 20.5424L18.8087 20.8282C18.0963 21.7389 17.7058 22.9321 17.6368 24.4083C17.5463 26.3428 18.0529 27.7948 19.1579 28.7657C19.9739 29.4826 21.0816 29.9364 22.4798 30.1274Z",
    fill: "url(#paint8_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8086 20.8284L16.7173 20.5426C16.9383 20.26 17.1905 20.0046 17.4736 19.7763C17.5097 19.7472 17.5463 19.7186 17.5833 19.6903L19.6746 19.9761C19.6376 20.0043 19.6011 20.0329 19.5649 20.062C19.2818 20.2903 19.0296 20.5457 18.8086 20.8284Z",
    fill: "url(#paint9_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6753 19.9761L17.584 19.6903C17.9162 19.437 18.2845 19.2193 18.6886 19.0373L20.78 19.3231C20.3758 19.505 20.0075 19.7227 19.6753 19.9761Z",
    fill: "url(#paint10_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7793 19.323L18.688 19.0372C19.463 18.6883 20.3702 18.4707 21.4092 18.3842L23.5005 18.6699C22.4615 18.7564 21.5543 18.9741 20.7793 19.323Z",
    fill: "url(#paint11_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5005 18.67L21.4092 18.3842C21.7659 18.3546 22.138 18.3403 22.5257 18.3416C23.0172 18.3431 23.4813 18.3692 23.9181 18.4201L26.0094 18.7058C25.5726 18.6549 25.1085 18.6288 24.6171 18.6273C24.2293 18.626 23.8572 18.6403 23.5005 18.67Z",
    fill: "url(#paint12_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0093 18.7056L23.918 18.4199C23.9862 18.4278 24.0538 18.4364 24.1207 18.4455L26.212 18.7312C26.1451 18.7221 26.0775 18.7136 26.0093 18.7056Z",
    fill: "url(#paint13_linear_1404_41489)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4963 27.1257C27.0812 26.5978 27.402 25.7022 27.461 24.4391C27.5202 23.1751 27.2832 22.2779 26.7479 21.7483C26.215 21.2179 25.4677 20.9507 24.5086 20.9477C23.5507 20.9447 22.7799 21.2072 22.1951 21.7341C21.6116 22.2601 21.2896 23.1557 21.2304 24.4197C21.1713 25.6828 21.4094 26.58 21.9435 27.1115C22.4789 27.6409 23.2249 27.9082 24.1828 27.9111C25.1419 27.9141 25.914 27.6517 26.4963 27.1257ZM29.5336 20.0931C30.6385 21.0639 31.1464 22.516 31.0559 24.4504C30.9654 26.3848 30.3219 27.8333 29.1264 28.7969C27.9309 29.7605 26.2473 30.2384 24.0743 30.2316C21.9024 30.2248 20.2629 29.7365 19.1579 28.7657C18.0529 27.7949 17.5462 26.3429 17.6368 24.4084C17.7273 22.474 18.3696 21.0255 19.565 20.0619C20.7605 19.0983 22.4453 18.6204 24.6172 18.6272C26.7902 18.634 28.4287 19.1223 29.5336 20.0931Z",
    fill: "#10BD89"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1284 4.14551L18.0371 3.85979L26.5601 -0.000347614L28.6514 0.285365L20.1284 4.14551Z",
    fill: "url(#paint14_linear_1404_41489)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5304 5.29712L20.4391 5.0114L18.0371 3.85993L20.1284 4.14564L22.5304 5.29712Z",
    fill: "url(#paint15_linear_1404_41489)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75623 29.7976L6.66491 29.5119L3.45752 28.0019L5.54884 28.2876L8.75623 29.7976Z",
    fill: "url(#paint16_linear_1404_41489)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6512 0.285624L28.2876 8.05913L25.7223 6.82858L8.75622 29.7976L5.54883 28.2876L22.5303 5.29724L20.1283 4.14577L28.6512 0.285624Z",
    fill: "#10BD89"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54884 28.2874L3.45752 28.0016L20.4389 5.01128L22.5303 5.297L5.54884 28.2874Z",
    fill: "url(#paint17_linear_1404_41489)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1404_41489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 10,
    width: 6,
    height: 2
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05079 11.573L5.95947 11.2872C6.14867 11.3131 6.348 11.3264 6.55745 11.327C7.51536 11.33 8.28739 11.0675 8.87095 10.5415L10.9623 10.8273C10.3787 11.3532 9.60668 11.6158 8.64878 11.6128C8.43932 11.6121 8.23999 11.5988 8.05079 11.573Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1404_41489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.05079 11.5729L5.95947 11.2872C5.98581 11.2908 6.01222 11.2942 6.03896 11.2973L8.13028 11.583C8.10362 11.5799 8.07712 11.5765 8.05079 11.5729Z",
    fill: "url(#paint18_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13038 11.583L6.03906 11.2973C6.20436 11.3166 6.37719 11.3264 6.55756 11.327C6.69992 11.3275 6.83824 11.3221 6.97242 11.3108L9.06374 11.5965C8.92956 11.6078 8.79125 11.6132 8.64888 11.6128C8.46851 11.6121 8.29568 11.6023 8.13038 11.583Z",
    fill: "url(#paint19_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06397 11.5964L6.97266 11.3107C7.39983 11.2748 7.78536 11.1795 8.12884 11.0249L10.2202 11.3107C9.87668 11.4652 9.49123 11.5605 9.06397 11.5964Z",
    fill: "url(#paint20_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2198 11.3105L8.12842 11.0248C8.33058 10.9338 8.51824 10.8224 8.69123 10.6905L10.7826 10.9762C10.6096 11.1081 10.4219 11.2196 10.2198 11.3105Z",
    fill: "url(#paint21_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7832 10.9763L8.69189 10.6906C8.75364 10.6435 8.81352 10.5938 8.87153 10.5415L10.9629 10.8272C10.9048 10.8795 10.845 10.9292 10.7832 10.9763Z",
    fill: "url(#paint22_linear_1404_41489)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1404_41489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 5,
    height: 7
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48242 4.4045L9.57374 4.69021C10.2499 4.78256 10.7972 5.03575 11.2145 5.45008C11.7486 5.98059 11.9867 6.87782 11.9276 8.14089C11.8684 9.40493 11.5465 10.3004 10.9629 10.8274L8.87156 10.5417C9.45512 10.0147 9.77712 9.11922 9.83627 7.85518C9.89534 6.59211 9.65728 5.6948 9.12315 5.16437C8.70585 4.75004 8.1586 4.49684 7.48242 4.4045Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1404_41489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9624 10.8274L8.87109 10.5417C8.96201 10.4596 9.04652 10.3686 9.12471 10.2687L11.216 10.5544C11.1378 10.6543 11.0533 10.7453 10.9624 10.8274Z",
    fill: "url(#paint23_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2165 10.5544L9.12517 10.2687C9.54911 9.7269 9.78636 8.92242 9.83627 7.85523C9.89534 6.59216 9.65728 5.69485 9.12315 5.16442C8.70585 4.75009 8.1586 4.49689 7.48242 4.40455L9.57374 4.69026C10.2499 4.78261 10.7972 5.03581 11.2145 5.45013C11.7486 5.98064 11.9867 6.87787 11.9276 8.14094C11.8777 9.20814 11.6404 10.0126 11.2165 10.5544Z",
    fill: "url(#paint24_linear_1404_41489)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1404_41489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 11,
    height: 12
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94712 13.8301L4.85579 13.5444C3.45653 13.3531 2.34897 12.8988 1.53261 12.1815C0.42756 11.2117 -0.0802387 9.75857 0.010269 7.82422C0.100696 5.89078 0.744297 4.44129 1.93978 3.4777C3.13518 2.51508 4.81884 2.03613 6.99192 2.04293C7.55952 2.04474 8.09066 2.07941 8.58541 2.14702L10.6767 2.43274C10.1821 2.3652 9.65084 2.33046 9.08324 2.32872C6.91017 2.32191 5.2265 2.80079 4.0311 3.76341C2.83562 4.72701 2.19201 6.1765 2.10159 8.10994C2.01108 10.0443 2.51888 11.4974 3.62393 12.4672C4.44029 13.1845 5.54785 13.6389 6.94712 13.8301Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1404_41489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.94711 13.8301L4.85579 13.5444C3.45653 13.3531 2.34897 12.8988 1.53261 12.1815C0.42756 11.2117 -0.0802387 9.75857 0.010269 7.82422C0.0793045 6.34889 0.470341 5.15544 1.1829 4.24451L3.27422 4.53023C2.56166 5.44116 2.17062 6.63467 2.10159 8.10994C2.01108 10.0443 2.51888 11.4974 3.62393 12.4672C4.44029 13.1845 5.54785 13.6389 6.94711 13.8301Z",
    fill: "url(#paint25_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.27394 4.53027L1.18262 4.24456C1.4039 3.96169 1.65622 3.70606 1.9395 3.47774C1.97531 3.44891 2.01161 3.42049 2.04831 3.39248L4.13964 3.6782C4.10293 3.7062 4.06663 3.73462 4.03082 3.76346C3.74755 3.99178 3.49522 4.24741 3.27394 4.53027Z",
    fill: "url(#paint26_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14015 3.67822L2.04883 3.39251C2.38137 3.13903 2.74988 2.92113 3.15445 2.73902L5.24585 3.02473C4.8412 3.20685 4.47269 3.42475 4.14015 3.67822Z",
    fill: "url(#paint27_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2457 3.02466L3.1543 2.73895C3.92941 2.39 4.83667 2.17217 5.87626 2.08566L7.96757 2.37138C6.92799 2.45788 6.02073 2.67571 5.2457 3.02466Z",
    fill: "url(#paint28_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96681 2.37151L5.87549 2.0858C6.23185 2.05613 6.60376 2.04188 6.99123 2.04306C7.4821 2.04459 7.94566 2.07079 8.38199 2.12151L10.4733 2.40723C10.037 2.3565 9.57342 2.33038 9.08256 2.32885C8.69508 2.3276 8.32316 2.34184 7.96681 2.37151Z",
    fill: "url(#paint29_linear_1404_41489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4741 2.40722L8.38281 2.12151C8.45104 2.1295 8.51861 2.13797 8.58554 2.14715L10.6769 2.43286C10.6099 2.42376 10.5424 2.41521 10.4741 2.40722Z",
    fill: "url(#paint30_linear_1404_41489)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9623 10.8273C11.546 10.3004 11.8679 9.40485 11.9271 8.14081C11.9861 6.87774 11.7481 5.98051 11.2139 5.45C10.6798 4.91957 9.93248 4.65331 8.97458 4.65032C8.01553 4.64733 7.24472 4.9088 6.66116 5.43576C6.07752 5.96272 5.75551 6.85822 5.69645 8.12136C5.6373 9.3854 5.87543 10.2826 6.40957 10.8131C6.94378 11.3426 7.68972 11.6098 8.64885 11.6128C9.60675 11.6158 10.3788 11.3533 10.9623 10.8273ZM13.9997 3.79477C15.1046 4.76552 15.6112 6.21863 15.5207 8.15207C15.4302 10.0865 14.7878 11.536 13.5924 12.4986C12.3969 13.4622 10.7133 13.9411 8.54027 13.9343C6.36719 13.9274 4.72882 13.4382 3.62393 12.4674C2.51887 11.4975 2.01107 10.0444 2.10158 8.1101C2.192 6.17666 2.83561 4.72717 4.03109 3.76358C5.22649 2.80095 6.91016 2.32208 9.08323 2.32889C11.2562 2.33562 12.8946 2.82492 13.9997 3.79477Z",
    fill: "#10BD89"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1404_41489",
    x1: 21.4946,
    y1: 27.7337,
    x2: 23.6654,
    y2: 27.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1404_41489",
    x1: 21.5742,
    y1: 27.7537,
    x2: 24.5988,
    y2: 27.7537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1404_41489",
    x1: 22.5073,
    y1: 27.6094,
    x2: 25.7545,
    y2: 27.6094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1404_41489",
    x1: 23.6631,
    y1: 27.2999,
    x2: 26.3154,
    y2: 27.2999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1404_41489",
    x1: 24.2236,
    y1: 27.0581,
    x2: 26.496,
    y2: 27.0581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1404_41489",
    x1: 24.4048,
    y1: 26.8461,
    x2: 26.7502,
    y2: 26.8461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1404_41489",
    x1: 23.0151,
    y1: 23.7771,
    x2: 27.4696,
    y2: 23.7771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1404_41489",
    x1: 23.6309,
    y1: 7.30095,
    x2: 28.2875,
    y2: 7.30095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1404_41489",
    x1: 15.5352,
    y1: 25.3349,
    x2: 22.4798,
    y2: 25.3349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1404_41489",
    x1: 16.7173,
    y1: 20.2593,
    x2: 19.6746,
    y2: 20.2593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1404_41489",
    x1: 17.584,
    y1: 19.5067,
    x2: 20.78,
    y2: 19.5067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1404_41489",
    x1: 18.688,
    y1: 18.8536,
    x2: 23.5005,
    y2: 18.8536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1404_41489",
    x1: 21.4092,
    y1: 18.5237,
    x2: 26.0094,
    y2: 18.5237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1404_41489",
    x1: 23.918,
    y1: 18.5756,
    x2: 26.212,
    y2: 18.5756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1404_41489",
    x1: 18.0371,
    y1: 2.07258,
    x2: 28.6514,
    y2: 2.07258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1404_41489",
    x1: 18.0371,
    y1: 4.57852,
    x2: 22.5304,
    y2: 4.57852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1404_41489",
    x1: 3.45752,
    y1: 28.8997,
    x2: 8.75623,
    y2: 28.8997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1404_41489",
    x1: 3.45752,
    y1: 16.6493,
    x2: 22.5303,
    y2: 16.6493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1404_41489",
    x1: 5.95947,
    y1: 11.4351,
    x2: 8.13028,
    y2: 11.4351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1404_41489",
    x1: 6.03906,
    y1: 11.4551,
    x2: 9.06374,
    y2: 11.4551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1404_41489",
    x1: 6.97266,
    y1: 11.3107,
    x2: 10.2202,
    y2: 11.3107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1404_41489",
    x1: 8.12842,
    y1: 11.0005,
    x2: 10.7826,
    y2: 11.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1404_41489",
    x1: 8.69189,
    y1: 10.7589,
    x2: 10.9629,
    y2: 10.7589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1404_41489",
    x1: 8.87109,
    y1: 10.548,
    x2: 11.216,
    y2: 10.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1404_41489",
    x1: 7.48242,
    y1: 7.4795,
    x2: 11.9364,
    y2: 7.4795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1404_41489",
    x1: 0,
    y1: 9.0373,
    x2: 6.94711,
    y2: 9.0373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1404_41489",
    x1: 1.18262,
    y1: 3.96138,
    x2: 4.13964,
    y2: 3.96138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1404_41489",
    x1: 2.04883,
    y1: 3.20862,
    x2: 5.24585,
    y2: 3.20862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1404_41489",
    x1: 3.1543,
    y1: 2.55516,
    x2: 7.96757,
    y2: 2.55516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1404_41489",
    x1: 5.87549,
    y1: 2.22511,
    x2: 10.4733,
    y2: 2.22511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1404_41489",
    x1: 8.38281,
    y1: 2.27718,
    x2: 10.6769,
    y2: 2.27718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#10888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215823"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentUp);
export default __webpack_public_path__ + "static/media/percentUp.03fdeae2a7a1e388abc523878f9b2b5f.svg";
export { ForwardRef as ReactComponent };